(() => {
  const root = document.documentElement;

  function setInset() {
    // visualViewport es la forma correcta de saber el "viewport visible"
    const vv = window.visualViewport;
    if (!vv) {
      root.style.setProperty('--pv-viewport-bottom-inset', '0px');
      return;
    }

    // Diferencia entre el alto del layout viewport y el alto visible real
    // (cuando hay barras del navegador, teclado, etc.)
    const inset = Math.max(0, window.innerHeight - (vv.height + vv.offsetTop));

    root.style.setProperty('--pv-viewport-bottom-inset', `${Math.round(inset)}px`);
  }

  setInset();
  window.addEventListener('resize', setInset);
  window.addEventListener('orientationchange', setInset);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', setInset);
    window.visualViewport.addEventListener('scroll', setInset);
  }
})();
